module.exports = __webpack_public_path__ + "static/Catch-393fa88badd356f83f453c6460bca2ac.webm";